import { render, staticRenderFns } from "./faqs-usuarios.vue?vue&type=template&id=6907e65a&lang=html"
import script from "./faqs-usuarios.vue?vue&type=script&lang=js"
export * from "./faqs-usuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports